// デモデータ（同梱サンプル）表示 ON/OFF の純ロジック（Supabase 非依存＝テスト可能）。
// 2026-08-27 オーナー決定・案C（OPEN-DECISIONS #17）。
//
// 設定ドキュメント settings/display: { demoData: boolean, updatedAt }
//   OFF（既定）= 正直な挙動: 実データ0件なら .ct-state.is-empty。サンプルは描画しない
//   ON         = 同梱サンプルを描画。ただし画面上に「デモデータ表示中」と明示する
//
// 対象は「サインイン済み・取得成功・実データ0件」のときだけ。
// 未サインイン／Supabase未設定の既存デモ経路（ctx.demo・online 初期値 false）は対象外＝従来どおりサンプル。
// 取得失敗（fetchError）は #52 のとおり is-error 主表示で短絡し、ここまで来ない。

// 既定は OFF。実運用が主で、実データのつもりで架空の数字を読む損害のほうが
// 「デモを見たいのに1回ONにする手間」より大きいため。設定が読めなかった場合も同じ側に倒す。
export const DEMO_DEFAULT_ON = false

// 設定ドキュメント → 真偽値。未作成・欠損・不正値はすべて既定（OFF）。
export function resolveDemoOn(doc) {
  if (!doc) return DEMO_DEFAULT_ON
  const v = doc.demoData
  if (v === true || v === 'true' || v === 1) return true
  if (v === false || v === 'false' || v === 0) return false
  return DEMO_DEFAULT_ON
}

// 全ビュー共通の唯一の判定：実データ0件のとき同梱サンプルを描いてよいか。
// online=false（明示的なデモ経路）は設定に関係なく従来どおり true。
export function allowSample(online, demoOn) {
  if (!online) return true
  return demoOn === true
}

// デモ明示バッジの文言（共通・1か所）。ビュー側の既存クラス（.bl-demo 等＝文字 --signal・枠 --accent）に載せる。
export const DEMO_TAG = 'デモデータ表示中：同梱サンプル（実CSV由来の架空の実績）。実データではありません'

// 実データ0件＋デモ表示OFF のときの共通の空状態（.ct-state.is-empty）。
// 「どこで切り替えられるか」まで書く＝OFFにした人が戻れなくならないようにする。
export function noDataHtml(what) {
  return `<div class="ct-state is-empty"><b class="ct-state__t">${what}の実データがまだありません</b>` +
    '<span>保存済みのデータが0件です。取込・登録を行うとここに表示されます。' +
    '同梱のサンプルで画面を確かめたいときは、ダッシュボードの「表示設定」でデモデータ表示をONにしてください</span>' +
    '<a class="btn" href="#/dashboard">ダッシュボードの表示設定へ</a></div>'
}
